import { DatePipe } from '@angular/common';
import { Component, OnInit,AfterViewInit,ViewChild,VERSION } from '@angular/core';
import { Ng2SmartTableModule,LocalDataSource } from 'ng2-smart-table';
import { NewVulnerabilityService } from 'src/app/Data Service/new-vulnerability.service';
import { Location } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { newVulClass } from 'src/app/Data Service/newVulClass';
// import { analyzeAndValidateNgModules } from '@angular/compiler';
import { CellDataRenderComp } from './CellDataRenderComp';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter } from 'rxjs/operators';
import {AppComponent} from 'src/app/app.component';
import { VulClass } from 'src/app/Data Service/VulClass';
import { RolegaurdService } from 'src/app/Data Service/rolegaurd.service';
/**
 * @title Table with sorting
 */

@Component({
  selector: 'app-home-grid',
  templateUrl: './home-grid.component.html',
  styleUrls: ['./home-grid.component.css']
})



export class HomeGridComponent implements OnInit {
// ng smartdatatable
oVuClass = new newVulClass();
name:string;
 
// data:any[] = [];
data : any[];
rdata : any[]=[];

public errorMessage: string = '';

settings = {
  columns: {
    DateRaised: {
       title: 'Date Raised',
       placeholder: "search",
      valuePrepareFunction: (DateRaised: any) => {
        return new DatePipe('en-US').transform(DateRaised, 'dd-MM-yyyy')
      },
      width: '10%',      
    },

    VRef: {
       title: 'GCC Ref',
      //type: 'html',
      type: 'custom',
      renderComponent : CellDataRenderComp,
//       valuePrepareFunction: (value: any) => { this.oVuClass.VRef = value;
//         return `<a href='/newvulnerability/${value}'>${value}</a>`;
//         // return `<a href="http://localhost:4200/newvulnerability">${value}</a>`;
// },
width: '10%'
    },
    CVE: {
       title: 'CVE',
      width: '20%',
      
    },
    Title: {
       title: 'Title',
      width: '60%'
      // type: 'html',
      // valuePrepareFunction: (Title: any) => {
      //   // return `<span style="margin-right: 720px">${Title}</span>`;
      //   return `<span class="cell_right">${Title}</span>`;
      // },
    }
  },
  
  pager: {
    display: true,
    perPage: 15,
    outerHeight:15,
  },
  actions: {
    add: false,
    delete: false,
    edit: false,     
  },
  // hideSubHeader: true
  
};


  constructor(public service : NewVulnerabilityService,private router: Router,
    private authService: MsalService, private msalBroadcastService: MsalBroadcastService 
    ,private appComp : AppComponent,private activatedRoute : ActivatedRoute
    ,private _roleGaurd : RolegaurdService) { 
      // if(!this.appComp.isLoggedIn()){
      //   console.log("not logged in");
      //   //this.data = this.activatedRoute.snapshot['data'] as VulClass[];
      // }
      // else{
      //   //console.log("logged in");
      //   // this.loadHomeGridData();
      //       this.data = this.activatedRoute.snapshot['data'] as VulClass[];
      //       console.log(this.data);
          

      //   // setTimeout(() => {
      //   //   this.data = this.activatedRoute.snapshot['data'] as VulClass[];
      //   // }, 2000);
        
      //   console.log("this.data after activated route ");
      //   console.log(this.data);
      //   //this.service.refreshListData();
      // }         
  }

  appUser() : boolean{
    const isUser = this._roleGaurd.appUser();    
    return isUser;
  }
  appAdmin() : boolean{
    const isAdmin = this._roleGaurd.appAdmin();    
    return isAdmin;
  }

  loadHomeGridData(){
    // if(this.appComp._refreshNeeded){
    //   this.reloadNGInit();
    // }
    //console.log("_refreshNeeded "+this.appComp._refreshNeeded);    
    //console.log(this.appComp._ngCallCount);

    this.data = [{CVE: "",
    DateRaised: "",
    Description: "",
    ExitCode: null,
    ExitMessage: null,
    LastUpdatedBy: null,
    LastUpdatedTimeStamp: "",
    Publish: null,
    VRef: ""
    }];

    //this.service.refreshListData();
    //this.service.getGridData();
      this.service.getGridData().subscribe((data : any)=>{      
      this.data = data as VulClass[];  

    }, (error:any) => {
      this.errorMessage = error;
  })
  //   this.service.getHomeGridData().subscribe((data : any)=>{      
  //     this.data = data as newVulClass[];  
  //     console.log("home grid data : ");
  //     console.log(this.data);
  //   }, (error:any) => {
  //     this.errorMessage = error;
  // })

}

ngOnInit(): void {
  // if(this.appComp.roleAssigned[0] == "Users" || this.appComp.roleAssigned[1] == "Users"){
  //   this.router.navigate(["/UserView"]);
  // }
  // else{
    //this.loadHomeGridData();
   //this.data = this.activatedRoute.snapshot['data'] as VulClass[];

  // this.msalBroadcastService.msalSubject$
  //   .pipe(
  //     filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
  //   )
  //   .subscribe((result: EventMessage) => {
  //     console.log("result" +EventType.LOGIN_SUCCESS);
  //     this.loadHomeGridData(); 
  //   });
/*comment for local
    if(!this.appComp.isLoggedIn()){
      console.log("not logged in");
    }
    else{
      //console.log("logged in");
      // this.loadHomeGridData();
      this.data = this.activatedRoute.snapshot['data'] as VulClass[];
      console.log("this.data after activated route ");
      console.log(this.data);
      //this.service.refreshListData();
    }
    **/
    this.service.refreshNeeded$
    .subscribe(() => { console.log("init refresh");
      this.loadHomeGridData();
    });
    this.loadHomeGridData();

  //}
   
}
  
}
